<div class="assignment-full-screen-content">
    <div class="assignment-full-screen-header">
        <div class="assignment-full-screen-header__top-row">
            <assignment-type *ngIf="data"
                             class="assignment-full-screen-header__assignment-type"
                             [record]="data"
                             showLabel
                             [disabled]="!assignmentEditable || data.readOnlyCriteria[pstFieldNames?.PSTAssignmentCoverageType]"
                             [value]="data?.coverageType"
                             (changed)="updateAssignment($event, pstFieldNames.PSTAssignmentCoverageType)">
            </assignment-type>
            <button class="assignment-full-screen-header-close-button"
                    (click)="close.emit()"
                    [matTooltip]="languageSettings.PSTWebCloseButtonLabel"
                    mat-icon-button>
                <mat-icon>
                    close
                </mat-icon>
            </button>
        </div>
        <div class="assignment-full-screen-header__text">
            <st-text-area-overlay required
                                  minRows="1"
                                  minHeight="1.75rem"
                                  [textToHighlight]="searchString"
                                  class="assignment-full-screen-header__title"
                                  panelClass="assignment-full-screen-header__title"
                                  [value]="data?.assignmentSlug"
                                  maxLength="50"
                                  disableNewLine
                                  [disabled]="!assignmentEditable"
                                  (changed)="updateAssignment($event, pstFieldNames.PSTAssignmentSlug)"
                                  [label]="languageSettings.PSTWebSlugPlaceholder"
                                  [placeholder]="languageSettings.PSTWebSlugPlaceholder"></st-text-area-overlay>

            <st-text-area-overlay class="assignment-full-screen-header__description"
                                  panelClass="assignment-full-screen-header__description"
                                  minRows="3"
                                  minHeight="1rem"
                                  [textToHighlight]="searchString"
                                  [value]="data?.coverage"
                                  [disabled]="!assignmentEditable"
                                  (changed)="updateAssignment($event, pstFieldNames.PSTAssignmentCoverage)"
                                  [required]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentCoverage]?.Required"
                                  [placeholder]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentCoverage]?.DefaultCaption"
                                  [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentCoverage]?.DefaultCaption"></st-text-area-overlay>
        </div>
        <div class="assignment-full-screen-header-meta">
            <div class="assignment-full-screen-header-meta-border-left"
                 leftBorder
                 [record]="data"></div>
            <date-time-picker class="assignment-full-screen-header-meta__date-picker"
                              *ngIf="globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentFileDate]?.Validation?.toUpperCase() == fieldDefValidations.TIME; else datePicker"
                              [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentFileDate]?.Required"
                              [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentFileDate]?.DefaultCaption"
                              (changed)="updateAssignment($event, pstFieldNames?.PSTAssignmentFileDate)"
                              [disabled]="!assignmentEditable || data.readOnlyCriteria[pstFieldNames?.PSTAssignmentFileDate]"
                              [value]="getDateTimeValue(pstFieldNames.PSTAssignmentFileDate)">
            </date-time-picker>
            <ng-template #datePicker>
                <date-picker class="assignment-full-screen-header-meta__date-picker"
                             [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentFileDate]?.Required"
                             [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentFileDate]?.DefaultCaption"
                             (changed)="updateAssignment($event, pstFieldNames?.PSTAssignmentFileDate)"
                             [disabled]="!assignmentEditable || data.readOnlyCriteria[pstFieldNames?.PSTAssignmentFileDate]"
                             [value]="getDateTimeValue(pstFieldNames.PSTAssignmentFileDate)">
                </date-picker>
            </ng-template>
            <div class="assignment-full-screen-header-meta-right">
                <status class="assignment-full-screen-header-meta__status"
                        [value]="data.status"
                        [disabled]="!assignmentEditable || data.readOnlyCriteria[pstFieldNames?.PSTAssignmentStatus]"
                        [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentStatus]?.Required"
                        (changed)="updateAssignment($event, pstFieldNames?.PSTAssignmentStatus)"
                        [placeholder]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentStatus]?.DefaultCaption"
                        [itemList]="globalTablesService.getListItemsForField(pstFieldNames?.PSTAssignmentStatus)">
                </status>
                <button class="assignment-full-screen-header-meta__approve"
                        *ngIf="globalTablesService.FieldDefsDict[pstFieldNames?.PSTApproved]?.AssignmentProp && assignmentEditable"
                        [matTooltip]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTApproved]?.DefaultCaption"
                        (click)="updateAssignment(!data.pstApproved, pstFieldNames.PSTApproved)"
                        [class.assignment-full-screen-header-meta__approve--active]="data.pstApproved"
                        mat-icon-button>
                    <mat-icon>done</mat-icon>
                </button>
                <button class="assignment-full-screen-header-meta__actions"
                        mat-icon-button
                        #trigger="cdkOverlayOrigin"
                        cdkOverlayOrigin
                        [disabled]="!assignmentEditable"
                        (click)="isPanelOpen = true">
                    <mat-icon>more_vert</mat-icon></button>
                <ng-template #externalActions>
                    <ng-template cdkConnectedOverlay
                                 [cdkConnectedOverlayOrigin]="trigger"
                                 [cdkConnectedOverlayOpen]="isPanelOpen"
                                 (overlayOutsideClick)="isPanelOpen = false">
                        <external-actions-overlay [data]="data"
                                                  inFullScreen
                                                  [editable]="assignmentEditable"
                                                  [isPanelOpen]="isPanelOpen"
                                                  [onDelete]="close"
                                                  (onActionClick)="isPanelOpen = false">
                        </external-actions-overlay>
                    </ng-template>
                </ng-template>
            </div>
        </div>
    </div>
    <div class="assignment-full-screen-main-content"
         [dir]="isRTL">
        <div class="assignment-full-screen-tags">
            <div class="assignment-full-screen-tags-label">
                <mat-icon class="assignment-full-screen-tags__icon">
                    tag
                </mat-icon>
                <span>{{globalTablesService.FieldDefsDict[pstFieldNames.PSTTopicTag]?.DefaultCaption}}</span>
            </div>
            <tags-autocomplete [value]="data?.tags"
                               maxItemsToShow="100"
                               [disabled]="!assignmentEditable || data.readOnlyCriteria[pstFieldNames?.PSTTopicTag]"
                               [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicTag]?.Required"
                               [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicTag]?.DefaultCaption"
                               (changed)="updateAssignment($event, pstFieldNames.PSTTopicTag)">

            </tags-autocomplete>
        </div>


        <div class="assignment-full-screen-owners">
            <div class="assignment-full-screen-owners-label">
                <mat-icon class="assignment-full-screen-owners__icon">
                    assignment_ind
                </mat-icon>
                <span>{{globalTablesService.FieldDefsDict[pstFieldNames.PSTAssignmentOwner]?.DefaultCaption}}</span>
            </div>
            <staff-id-list-multiple [value]="data?.storyOwner"
                                    [disabled]="!assignmentEditable  || data.readOnlyCriteria[pstFieldNames?.PSTAssignmentOwner]"
                                    (changed)="updateAssignment($event, pstFieldNames.PSTAssignmentOwner)"
                                    [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentOwner]?.Required"
                                    [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentOwner]?.DefaultCaption"></staff-id-list-multiple>
        </div>


        <div class="assignment-full-screen-desks">
            <div class="assignment-full-screen-desks-label">
                <mat-icon class="assignment-full-screen-desks__icon">
                    apartment
                </mat-icon>
                <span>{{globalTablesService.FieldDefsDict[pstFieldNames.PSTAssignmentPublishingDesk]?.DefaultCaption}}</span>
            </div>
            <check-list [value]="data?.department"
                        [disabled]="!assignmentEditable || data.readOnlyCriteria[pstFieldNames?.PSTAssignmentPublishingDesk]"
                        [itemList]="globalTablesService.getListItemsForDesk(data.type)"
                        (changed)="updateAssignment($event, pstFieldNames.PSTAssignmentPublishingDesk)"
                        [required]="enforceRequiredFieldsOnCreate && globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentPublishingDesk]?.Required"
                        [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentPublishingDesk]?.DefaultCaption"></check-list>
        </div>
        <mat-accordion class="assignment-full-screen-accordion"
                       multi>
            <ng-template ngFor
                         let-group
                         [ngForOf]="groups"
                         let-i="index">
                <ng-container [ngSwitch]="group.dynamic">
                    <ng-template [ngSwitchCase]="false">
                        <ng-container [ngSwitch]="group.name">
                            <ng-template [ngSwitchCase]="languageSettings.PSTWebAttachmentsPane">
                                <pane-container *ngIf="showAttachments && assignmentEditable"
                                                #paneContainer
                                                class="assignment-full-screen-accordion-pane-container"
                                                [expanded]="visualStateService.expanderSettingsMap['ASSIGNMENT']?.[attachmentsFiedGroupLabel]"
                                                (panelStateChanged)="panelStateChanged($event, 'ASSIGNMENT', attachmentsFiedGroupLabel)">
                                    <span title>{{attachmentsFiedGroupLabel}}</span>

                                    <ng-container actions>
                                        <button mat-icon-button
                                                (click)="expandCollapseAll(paneContainer)"
                                                class="assignment-full-screen-accordion-pane-container-expand-collapse"
                                                [matTooltip]="paneContainer?.expanded ? collapseAllLabel : expandAllLabel"
                                                click-stop-propagation>
                                            <mat-icon fontSet="material-symbols-outlined">
                                                {{paneContainer?.expanded ? 'collapse_all' : 'expand_all'}}
                                            </mat-icon>
                                        </button>
                                    </ng-container>
                                    <attachments-list [record]="data"
                                                      [property]="pstFieldNames.PSTExternalFiles"
                                                      securityPrivilegeObject="assignment">
                                    </attachments-list>
                                </pane-container>
                            </ng-template>
                            <ng-template ngSwitchDefault
                                         ngFor
                                         let-item
                                         [ngForOf]="specialProps"
                                         let-i="index">
                                <pane-container *ngIf="item?.Validation?.toUpperCase() == fieldDefValidations.SPECIAL && group.name == item.DefaultCaption"
                                                #paneContainer
                                                class="assignment-full-screen-accordion-pane-container"
                                                [expanded]="visualStateService.expanderSettingsMap['ASSIGNMENT']?.[item?.DefaultCaption]"
                                                (panelStateChanged)="panelStateChanged($event, 'ASSIGNMENT', item.DefaultCaption)">
                                    <span title>{{item.DefaultCaption}}</span>
                                    <ng-container actions>
                                        <button mat-icon-button
                                                (click)="expandCollapseAll(paneContainer)"
                                                class="assignment-full-screen-accordion-pane-container-expand-collapse"
                                                [matTooltip]="paneContainer?.expanded ? collapseAllLabel : expandAllLabel"
                                                click-stop-propagation>
                                            <mat-icon fontSet="material-symbols-outlined">
                                                {{paneContainer?.expanded ? 'collapse_all' : 'expand_all'}}
                                            </mat-icon>
                                        </button>
                                    </ng-container>
                                    <special [value]="getValue(item.ID, item.Validation)"
                                             (changed)="updateAssignment($event, item.ID)"
                                             [disabled]="!assignmentEditable"
                                             [columns]="globalTablesService.getListColumnsForSpecialField(item.ID)">
                                    </special>
                                </pane-container>
                                <pane-container *ngIf="item?.Validation?.toUpperCase() == fieldDefValidations.COST && group.name == item.DefaultCaption"
                                                #paneContainer
                                                class="assignment-full-screen-accordion-pane-container"
                                                [expanded]="visualStateService.expanderSettingsMap['ASSIGNMENT']?.[item?.DefaultCaption]"
                                                (panelStateChanged)="panelStateChanged($event, 'ASSIGNMENT', item.DefaultCaption)">
                                    <span title>{{item.DefaultCaption}}</span>
                                    <ng-container actions>
                                        <button mat-icon-button
                                                (click)="expandCollapseAll(paneContainer)"
                                                class="assignment-full-screen-accordion-pane-container-expand-collapse"
                                                [matTooltip]="paneContainer?.expanded ? collapseAllLabel : expandAllLabel"
                                                click-stop-propagation>
                                            <mat-icon fontSet="material-symbols-outlined">
                                                {{paneContainer?.expanded ? 'collapse_all' : 'expand_all'}}
                                            </mat-icon>
                                        </button>
                                    </ng-container>
                                    <special-cost [required]="enforceRequiredFieldsOnCreate && item.Required"
                                                  [value]="getValue(item.ID, item.Validation)"
                                                  [disabled]="!assignmentEditable"
                                                  (changed)="updateAssignment($event, item.ID)"
                                                  [columns]="globalTablesService.getListColumnsForSpecialField(item.ID)"></special-cost>
                                </pane-container>
                            </ng-template>
                        </ng-container>
                    </ng-template>
                    <ng-template ngSwitchDefault>
                        <pane-container *ngIf="data.visibilityCriteriaGroups[group?.name]"
                                        #paneContainer
                                        class="assignment-full-screen-accordion-pane-container"
                                        [class.assignment-full-screen-accordion-pane-container-required]="enforceRequiredFieldsOnCreate && !data.requiredFieldsGroups[group?.name]"
                                        [expanded]="visualStateService.expanderSettingsMap['ASSIGNMENT']?.[getFieldGroupsLabel(group)]"
                                        (panelStateChanged)="panelStateChanged($event, 'ASSIGNMENT', getFieldGroupsLabel(group))">
                            <span title>{{getFieldGroupsLabel(group)}}</span>
                            <ng-container actions>
                                <button mat-icon-button
                                        (click)="expandCollapseAll(paneContainer)"
                                        class="assignment-full-screen-accordion-pane-container-expand-collapse"
                                        [matTooltip]="paneContainer?.expanded ? collapseAllLabel : expandAllLabel"
                                        click-stop-propagation>
                                    <mat-icon fontSet="material-symbols-outlined">
                                        {{paneContainer?.expanded ? 'collapse_all' : 'expand_all'}}
                                    </mat-icon>
                                </button>
                            </ng-container>

                            <div class="assignment-full-screen-accordion-pane-container-property-group__container">
                                <div class="assignment-full-screen-accordion-pane-container-property-group">
                                    <ng-template ngFor
                                                 let-item
                                                 [ngForOf]="getList(group.name)"
                                                 let-j="index">
                                        <ng-template [ngIf]="data.visibilityCriteria[item?.ID]">
                                            <div
                                                 class="assignment-full-screen-accordion-pane-container-property__container">
                                                <span
                                                      class="assignment-full-screen-accordion-pane-container-property__label">{{item.DefaultCaption}}
                                                </span>
                                                <text-field [disabled]="item.ReadOnlyValue || !assignmentEditable || data.readOnlyCriteria[item.ID]"
                                                            *ngIf="((item?.Validation?.toUpperCase() == 'TEXT') && (item.WordWrap == false))"
                                                            [required]="enforceRequiredFieldsOnCreate && item.Required"
                                                            [tabindex]="j"
                                                            showLinks
                                                            [textToHighlight]="searchString"
                                                            [label]="item.DefaultCaption"
                                                            (changed)="updateAssignment($event, item.ID)"
                                                            [value]="data.get(item.ID)"></text-field>
                                                <st-text-area [disabled]="item.ReadOnlyValue || !assignmentEditable || data.readOnlyCriteria[item.ID]"
                                                              *ngIf="((item.Validation.toUpperCase() == 'TEXT') && (item.WordWrap == true))"
                                                              [required]="enforceRequiredFieldsOnCreate && item.Required"
                                                              [tabindex]="j"
                                                              showLinks
                                                              [textToHighlight]="searchString"
                                                              (changed)="updateAssignment($event, item.ID)"
                                                              [label]="item.DefaultCaption"
                                                              [value]="data.get(item.ID)"></st-text-area>
                                                <combo-box [disabled]="item.ReadOnlyValue || !assignmentEditable || data.readOnlyCriteria[item.ID]"
                                                           [required]="enforceRequiredFieldsOnCreate && item.Required"
                                                           [tabindex]="j"
                                                           [label]="item.DefaultCaption"
                                                           [addEmptyOption]="!item.Required"
                                                           *ngIf="(item.Validation.toUpperCase() == 'COMBOBOX')"
                                                           [value]="data.get(item.ID)"
                                                           (changed)="updateAssignment($event, item.ID)"
                                                           [itemList]="globalTablesService.getListItems(item.ID, item.List)">
                                                </combo-box>
                                                <check-list [disabled]="item.ReadOnlyValue || !assignmentEditable || data.readOnlyCriteria[item.ID]"
                                                            [required]="enforceRequiredFieldsOnCreate && item.Required"
                                                            [tabindex]="j"
                                                            [label]="item.DefaultCaption"
                                                            *ngIf="(item.Validation.toUpperCase() == 'CHECKLIST')"
                                                            [value]="getCheckListValue(item.ID)"
                                                            (changed)="updateAssignment($event, item.ID)"
                                                            [itemList]="globalTablesService.getListItems(item.ID, item.List)"></check-list>
                                                <check-box [disabled]="item.ReadOnlyValue || !assignmentEditable || data.readOnlyCriteria[item.ID]"
                                                           [tabindex]="j"
                                                           [label]="item.DefaultCaption"
                                                           (changed)="updateAssignment($event, item.ID)"
                                                           *ngIf="(item.Validation.toUpperCase() == 'CHECKBOX')"
                                                           [value]="data.get(item.ID)">
                                                </check-box>
                                                <date-picker [disabled]="item.ReadOnlyValue || !assignmentEditable || data.readOnlyCriteria[item.ID]"
                                                             *ngIf="item.Validation.toUpperCase() == 'DATE'"
                                                             [required]="enforceRequiredFieldsOnCreate && item.Required"
                                                             [tabindex]="j"
                                                             [min]="getMinDate(item.ID)"
                                                             [label]="item.DefaultCaption"
                                                             (changed)="updateAssignment($event, item.ID)"
                                                             [value]="getDateTimeValue(item.ID)">
                                                </date-picker>
                                                <date-time-picker [disabled]="item.ReadOnlyValue || !assignmentEditable || data.readOnlyCriteria[item.ID]"
                                                                  *ngIf="(item.Validation.toUpperCase() == 'TIME' ||
                                                                item.Validation.toUpperCase() == 'MOSDATETIME')"
                                                                  [required]="enforceRequiredFieldsOnCreate && item.Required"
                                                                  [tabindex]="j"
                                                                  [min]="getMinDate(item.ID)"
                                                                  [label]="item.DefaultCaption"
                                                                  (changed)="updateAssignment($event, item.ID)"
                                                                  [value]="getDateTimeValue(item.ID)">
                                                </date-time-picker>
                                                <date-time-range [disabled]="item.ReadOnlyValue || !assignmentEditable || data.readOnlyCriteria[item.ID]"
                                                                 [required]="enforceRequiredFieldsOnCreate && item.Required"
                                                                 [tabindex]="j"
                                                                 [label]="item.DefaultCaption"
                                                                 (changed)="updateAssignment($event, item.ID)"
                                                                 *ngIf="item.Validation.toUpperCase() == 'DATETIMERANGE'"
                                                                 [value]="getDateRangeValue(item.ID)">
                                                </date-time-range>
                                                <staff-id-list-multiple [disabled]="item.ReadOnlyValue || !assignmentEditable || data.readOnlyCriteria[item.ID]"
                                                                        [required]="enforceRequiredFieldsOnCreate && item.Required"
                                                                        [tabindex]="j"
                                                                        [label]="item.DefaultCaption"
                                                                        (changed)="updateAssignment($event, item.ID)"
                                                                        *ngIf="(item.Validation.toUpperCase() == 'STAFFIDLIST')"
                                                                        [value]="getStaffIdValue(item.ID)">
                                                </staff-id-list-multiple>
                                                <tree [disabled]="item.ReadOnlyValue || !assignmentEditable || data.readOnlyCriteria[item.ID]"
                                                      [required]="enforceRequiredFieldsOnCreate && item.Required"
                                                      [tabindex]="j"
                                                      [label]="item.DefaultCaption"
                                                      (changed)="updateAssignment($event, item.ID)"
                                                      *ngIf="(item.Validation.toUpperCase() == 'TREE')"
                                                      [value]="data.get(item.ID)"
                                                      [itemList]="globalTablesService.getlistItemsForTree(item.List)">
                                                </tree>
                                                <address-form [required]="enforceRequiredFieldsOnCreate && item.Required"
                                                              [tabindex]="j"
                                                              [disabled]="item.ReadOnlyValue || !assignmentEditable || data.readOnlyCriteria[item.ID]"
                                                              [label]="item.DefaultCaption"
                                                              (changed)="updateAssignment($event, item.ID)"
                                                              *ngIf="(item.Validation.toUpperCase() == 'ADDRESS')"
                                                              [value]="data.get(item.ID)"></address-form>
                                            </div>
                                        </ng-template>
                                    </ng-template>
                                </div>
                            </div>
                        </pane-container>
                    </ng-template>
                </ng-container>
            </ng-template>
        </mat-accordion>
    </div>
</div>
<div class="assignment-full-screen-pager">
    <button mat-icon-button
            (click)="navigate($event, NavigationDirection.FIRST)"
            class="assignment-screen-pager-button-first">
        <mat-icon>first_page</mat-icon>
    </button>
    <button mat-icon-button
            (click)="navigate($event, NavigationDirection.PREVIOUS)"
            class="assignment-screen-pager-button-previous">
        <mat-icon>navigate_before</mat-icon>
    </button>
    <span class="assignment-full-screen-pager-text">Assignment {{indexInParentToShow}}/{{totalCount}}</span>
    <button mat-icon-button
            (click)="navigate($event, NavigationDirection.NEXT)"
            class="assignment-screen-pager-button-next">
        <mat-icon>navigate_next</mat-icon>
    </button>
    <button mat-icon-button
            (click)="navigate($event, NavigationDirection.LAST)"
            class="assignment-screen-pager-button-last">
        <mat-icon>last_page</mat-icon>
    </button>
</div>
